import { Fragment, ReactElement } from 'react'
import styled from 'styled-components'

import { SectionDiv } from '../TextStyle'
import { snsItems, snsLinks } from './SNSItems'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/enlayout'
import { Head } from '@/components/enlayouts/Head'
import { Index } from '@/components/enlayouts/Legal/Index'
import { SectionTitle } from '@/components/enlayouts/Legal/SectionTitle'

const sectionTitle = {
  children: (
    <h2>
      Social Media Policy
    </h2>
  ),
}

export const SNSPage = () => {
  return (
    <>
      <Head
        title="Social Media Policy"
        description="The SNS policy for TRIAL Holdings, Inc."
        ogp={{ type: 'article', url: 'en/legal/sns-policy/' }}
      />
      <SnsContainer>
        <SectionTitle {...sectionTitle} />
        <Spacer h={{ pc: 70, sp: 60 }} />
        <Index columnGap={25} listType="article" links={snsLinks} />
        <Spacer h={{ pc: 70, sp: 39 }} />
        {snsItems.map(({ children, id }, index) => (
          <Fragment key={`${id}${index}`}>
            <SectionDiv id={id}>{children}</SectionDiv>
            {index < snsItems.length - 1 && <Spacer h={{ pc: 70, sp: 39 }} />}
          </Fragment>
        ))}
      </SnsContainer>
    </>
  )
}
SNSPage.getLayout = (page: ReactElement) => {
  const pageTitle = {
    title: 'Legal',
    subTitle: '',
  }

  const breadCrumbs = [
    { name: 'Home', path: '/en/' },
    { name: 'Legal', path: '/en/legal/' },
    { name: 'Social Media Policy', path: '' },
  ]

  return (
    <TitleLayout
      {...pageTitle}
      breadCrumbs={breadCrumbs}
      isRequiredBackground={false}
    >
      {page}
    </TitleLayout>
  )
}

const SnsContainer = styled.div`
  width: 1040px;
  padding-top: 62px;
  padding-bottom: 130px;
  margin: 0 auto;

  @media screen and (max-width: 1047px) {
    width: 100%;
    padding: 40px 20px 70px;
  }
`
